import React from "react";
import GenericEditForm from "../../components/GenericEditForm";

function EditBrand() {
  return (
    <GenericEditForm
      title="Marca"
      endpoint="/brands"
      backTo="/brands"
      fields={[
        {
          name: "name",
          label: "Nombre",
          type: "text",
          placeholder: "Nombre de la marca",
          required: true,
        },
        {
          name: "description",
          label: "Descripción",
          type: "textarea",
          placeholder: "Descripción de la marca",
          required: false,
        },
      ]}
    />
  );
}

export default EditBrand;
